<template>
    <div >
        <div>
            <!-- Window with an enlarged image -->
             <Popup v-if="popupSwitch == true" :contentType="'slider'" :items="filteredItems" />
            <Enlarge />
            <!-- the the middle section of the page - Slider, List, Search-->
            <!-- Header -->
            <div class="brands">
                <h4 ref="type" style="color: #1997c6 !important">SELECT {{getType() == 'cpu' ? 'Processor' : getType()}}</h4>
            </div>
            <div class="searchbar-section">
                <!-- Searchbar -->
                <form v-on:submit.prevent="onSubmit" class="searchbar">
                    <input v-model="search" class="form-control" type="text" data-action="grow" placeholder="Search">
                </form>
                <!-- NAVBAR -->
                <smallnav v-if="getFetchedItems" :viewModes="viewModes" :items="filteredItems"/>
            </div>
            <!-- ADVANCED -->
            <div v-if="getLayout == 'advanced'" class="advanced">
                <div class="left-side-page">
                    <!--Main Active Frame -->
                    <div class="items-display">                      
                        <!-- SLIDER -->
                        <div v-if="allItemsLoaded" class="slider-container"> 
                            <Slider 
                            v-if="this.viewModes[0].chosen == true" 
                            class="slider" 
                            :items="filteredItems"/>
                        </div>
                        <!-- Searchbar  --LIST-->
                        <form class="searchbar" v-if="this.viewModes[1].chosen == true">
                            <input v-model="search" class="form-control" type="text" data-action="grow" placeholder="Search">
                        </form>
                        <!-- LIST -->
                        <List v-if="this.viewModes[1].chosen == true" :mode="'cpu'" :items="filteredItems" :search="search"/>                    
                    </div>
                </div>
            </div>
            <!-- SIMPLE -->
            <div style="margin-left: -8px; min-height: 550px; position: relative"  v-if="getLayout == 'simple' || getLayout == 'album'" class="demo">
                <!-- LIST -->
                <Loader v-if="!allItemsLoaded" />
                <List v-if="allItemsLoaded || allItemsLoaded == ''"  :mode="'cpu'" :layout="'demo'" :items="filteredItems" :search="search"/>   
                <div v-if="(allItemsLoaded || allItemsLoaded == '') && listExtended == false && filteredItems && filteredItems.length >4"  :mode="'cpu'" :layout="'demo'" class="extend-list-button" @click="extendList()"><i class="icon icon-chevron-thin-down"></i></div>
                <div v-if="(allItemsLoaded || allItemsLoaded == '') && listExtended == true && filteredItems && filteredItems.length >4"  :mode="'cpu'" :layout="'demo'" class="extend-list-button" @click="extendList()"><i class="icon icon-chevron-thin-up"></i></div>
            </div>
            <!-- COMPARE -->
            <div style="margin-left: -8px; margin-right: 8px; position: relative"  v-if="getLayout == 'compare'" class="demo">
                <!-- LIST -->
                <Loader v-if="!allItemsLoaded" />
                <Compare v-if="allItemsLoaded || allItemsLoaded == ''"  :mode="'cpu'" :items="getCompareList" />   
            </div>
        </div>  
    </div>
</template>

<script>
import { mapGetters }           from 'vuex';
import { mapActions }           from 'vuex'
import Slider                   from './Slider.vue'
import { EventBus }             from '../../eventBus'
import smallnav                 from './smallnav.vue'
import Enlarge                  from '../default/Enlarge'
import List                     from './List'
import Loader                   from '../widgets/loader.vue'
import Popup                    from '../Popup.vue'
import {functions}              from '../../functions'
import Compare                  from './Compare.vue'

export default {
    name: "CPU",   
    components: {
        Slider,
        smallnav,
        Enlarge,
        List,
        Loader,
        Popup,
        Compare
    },
    watch: {
        // search(n){{
        //     this.search =  n.split(' ').join('')
        // }},
    },
    data() {
        return {
            result: {},
            compareList: null,
            search: "",
            type: this.$route.path.replace(/\\|\/builder\//g,'') ,
            activeFiltersV2: [],
            viewModes: [
                {
                    id: 1,
                    name: "Slider",
                    chosen: true
                },
                {
                    id: 2,
                    name: "List",
                    chosen: false
                }
            ],
            attribs: [],
            items: this.getItems,
            popupSwitch: false,
            listExtended: false
        }
    },
    computed: {
        ...mapGetters([
            'getLayout',
            'getItems',
            'getCompareList',
            'getFetchedItems',
            'allItemsLoaded',
            'getCompatibleMode',
            'getCompatLib',
            'getBuild',
            'allMenuOptions'
        ]),
        filteredItems: function(){  
            var filtList = this.getFilteredList(this.getFetchedItems, this.activeFiltersV2, this.allMenuOptions)         
            this.setItems(filtList)
            return filtList
        },
        scrollToTop() {
           return window.scrollTo(0,0);
        },
    },
    methods: {       
         ...mapActions([
            'getLastRoute',
            'fetchItems',
            'setCurrentPartType',
            'setLayout',
            'checkPartCompat',
            'setItems',
        ]),
        extendList(){
            EventBus.$emit('extendList', 'status')
        },
        getType(){
            var type = this.$route.query.type 
            return type
        },
        checkPartCompat:    ({compatTable, type, asin}) => functions.checkPartCompat({compatTable, type, asin}),
        getFilteredList(items, attribs, build) {
            console.log('got Build', this.getType())
            var types = []
            var query = this.search.split(' ').join('').toLowerCase()
            var multiQueryParams = this.search.split(/[-,_ ]+/)
            multiQueryParams = multiQueryParams.filter(itm => itm !== '' && itm !== ' ')
            var result = []
            if(items && items !== null && typeof(attribs) == 'object' && Object.keys(attribs).length >0){
                console.log('filtering ', items, ' with attribs ', attribs)
                items.map(item => {
                if(attribs[item.type]){
                    Object.keys(attribs[item.type]).map(option => {
                    if(option == 'RAM_Type' && item.type == 'cpu'){
                        option = 'ram'
                    }
                    if(item.compat[option]){
                    }
                    if(item.specs[option]){
                    }
                    })
                }
                })
            }
            if(items && items !== null && items.length >0){
                if (multiQueryParams.length > 0) {
                    if(multiQueryParams.length > 0){
                        var tmpList = []
                        for(var i = 0; i < multiQueryParams.length; i ++){
                            var quer = multiQueryParams[i]
                            tmpList[i] = []
                            if(quer !== ''){
                                var itemsList = []
                                if(tmpList[i-1]){
                                    itemsList = tmpList[i-1]
                                }
                                else {
                                    itemsList = items
                                }
                                itemsList.map((item) => {
                                    if(
                                    item.model.toLowerCase().split(' ').join('').includes(quer)
                                    || item.asin.toLowerCase().split(' ').join('').includes(quer)
                                    || JSON.stringify(item).toLowerCase().split(' ').join('').includes(this.activeFilters)
                                    || (item.type.toLowerCase() == 'cpu' 
                                        && 
                                            (
                                            item.compat.socket.toLowerCase().split(' ').join('').includes(quer)
                                            || item.compat.brand.toLowerCase().split(' ').join('').includes(quer)
                                            )
                                        )
                                    || (item.type.toLowerCase() == 'motherboard' 
                                        && (
                                            item.compat.socket.toLowerCase().split(' ').join('').includes(quer) 
                                            || item.compat.brand.toLowerCase().split(' ').join('').includes(quer)
                                            || item.compat.cpu_brand.toLowerCase().split(' ').join('').includes(quer)
                                            || item.specs.Compatible_Memory.toLowerCase().split(' ').join('').includes(quer)
                                            || item.form_factor.toLowerCase().split(' ').join('').includes(quer)
                                            // || item.specs.Compatible_Memory.toLowerCase().split(' ').join('').includes(quer)
                                            )
                                        )
                                    || (item.type.toLowerCase() == ('graphics' || 'gpu')
                                        && 
                                            (
                                                item.brand.toLowerCase().split(' ').join('').includes(quer)
                                                || item.specs.graphics_ram_capacity.split(' ').join('').toLowerCase().split(' ').join('').includes(quer)
                                                || item.specs.graphics_ram_type.split(' ').join('').toLowerCase().split(' ').join('').includes(quer)
                                                || item.specs.memory_bus_width.split(' ').join('').toLowerCase().split(' ').join('').includes(quer)
                                            )
                                        )
                                    || (item.type.toLowerCase() == 'ram'
                                        && 
                                            (
                                                item.brand.toLowerCase().split(' ').join('').includes(quer)
                                                || item.specs.Capacity.split(' ').join('').toLowerCase().split(' ').join('').includes(quer)
                                                || item.specs.RAM_Speed.split(' ').join('').toLowerCase().split(' ').join('').includes(quer)
                                                || item.specs.RAM_Type.split(' ').join('').toLowerCase().split(' ').join('').includes(quer)
                                            )
                                        )
                                    || (item.type.toLowerCase() == 'storage'
                                        && 
                                            (
                                                item.brand.toLowerCase().split(' ').join('').includes(quer)
                                                || item.specs.Capacity.split(' ').join('').toLowerCase().split(' ').join('').includes(quer)
                                                || item.specs.Disk_Type.split(' ').join('').toLowerCase().split(' ').join('').includes(quer)
                                                || item.specs.hardware_interface.split(' ').join('').toLowerCase().split(' ').join('').includes(quer)
                                            )
                                        )
                                    || (item.type.toLowerCase() == 'psu'
                                        && 
                                            (
                                                item.brand.toLowerCase().split(' ').join('').includes(quer)
                                                || item.specs.energy_rating.split(' ').join('').toLowerCase().split(' ').join('').includes(quer)
                                                || item.specs.wattage.split(' ').join('').toLowerCase().split(' ').join('').includes(quer)
                                                || item.compat.form_factor.split(' ').join('').toLowerCase().split(' ').join('').includes(quer)
                                            )
                                        )
                                    || (item.type.toLowerCase() == 'case'
                                        && 
                                            (
                                                item.brand.toLowerCase().split(' ').join('').includes(quer)
                                                || item.specs.color.split(' ').join('').toLowerCase().split(' ').join('').includes(quer)
                                                || item.specs.I_O_ports.split(' ').join('').toLowerCase().split(' ').join('').includes(quer)
                                                || item.compat.form_factor.split(' ').join('').toLowerCase().split(' ').join('').includes(quer)
                                            )
                                        )
                                    )
                                    {
                                        tmpList[i].push(item)
                                    }
                                });
                            }
                            
                        }
                        result = tmpList[tmpList.length -1]
                    }
                    
                } 
                if(result.length >0){
                    if(this.getCompatibleMode == true){
                        return result.filter((item) => {
                            return this.checkPartCompat({compatTable: this.getCompatLib, type: item.type, asin: item.asin}) !==false
                        })
                    }
                    else {
                        return result
                    }
                }
                if(result.length == 0){
                    if(this.getCompatibleMode == true){
                        return items.filter((item) => {
                            return this.checkPartCompat({compatTable: this.getCompatLib, type: item.type, asin: item.asin}) !==false
                        })
                    }
                    else if(query == ''){
                        return items
                    }
                    else return result
                }
            }
            // else return this.getFetchedItems;
            else return this.result;
        },
        popup(){
            this.setLayout('advanced')
        },
        onSubmit(){
            return
        },
        setItems(){
            this.items = this.getFetchedItems
        },
        getType(){
            this.type = this.$route.path.replace(/\\|\/builder\//g,'') 
            return this.type
        },
        updateRoute(){
            this.getLastRoute(this.$route.path)
        },
        frequency(spec){
            var maxFrequency = 5.2;
            var currentFrequency = parseFloat(spec);
            var frequencyIndex = currentFrequency*100/maxFrequency
            EventBus.$emit('frequency', frequencyIndex)
            return frequencyIndex +"%"
        },
        updateCompareList(){
            this.compareList = this.getCompareList
        },
        getAttribs(){
            if(this.getFetchedItems !== null){
                this.attribs = this.getFetchedItems.attribs
            }
        },
    },
    mounted() {
        this.setLayout('simple')
        this.setItems(this.items)
        this.getType();
        EventBus.$on('frequency', (frequencyIndex) => {
            this.frequencyGHZ = parseInt(parseFloat(frequencyIndex)*100);
            parseInt(this.frequencyGHZ)
            console.log('frequency emited, frequencyGHZ: '+this.frequencyGHZ)
        });
        EventBus.$on('emitTypeChange', () => {
            this.setItems()
            this.search = ''
        });
        EventBus.$on('extendListResponse', (bool) => {
            this.listExtended = bool        
        })
    },
    updated(){
        this.updateRoute(); 
        this.updateCompareList()
    },
    created () {
        this.setCurrentPartType(this.getType())
        this.fetchItems()
        
        this.updateRoute();
        
        if(this.allItemsLoaded){
            console.log(this.$store.getters.getFetchedItems)
        }
        this.getAttribs();
    }
}
</script>
<style scoped>
@import '../../assets/css/builder.css';
.advanced {
    max-height: 700px;
}
::-webkit-scrollbar { 
   display:unset !important; 
}
.extend-list-button {
    text-align: center;
    padding-top: 5px;
    position: absolute;
    left: 0px;
    right: 0px;
    margin-top: 5px;
    height: 32px;
    cursor: pointer;
    font-size: 22px;
    transition: 0.2s;
    color: #9198aa
}
.extend-list-button:hover {
    color: #1997c6;
    font-size: 24px;
}
</style>